export default "__VITE_ASSET__DU4XqOXJ__"